/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
import Vue from "vue";
/* eslint-enable */

export default createPerimeter({
  purpose: 'base',
  can: {
    view() {
      return authoritiesHavePermission("LOGIN");
    },
    installDevice() {
      return authoritiesHavePermission("INSTALL_DEVICES");
    },
    uninstallDevice() {
      return authoritiesHavePermission("UNINSTALL_DEVICES");
    },
    createCircuitPole() {
      return authoritiesHavePermission( "CREATE_CIRCUITS_POLES");
    },
    editCircuitPole() {
      return authoritiesHavePermission("EDIT_CIRCUITS_POLES");
    },
    viewDeviceConfiguration() {
      return authoritiesHavePermission("VIEW_DEVICE_CONFIGURATION");
    },
    editDeviceConfiguration() {
      return authoritiesHavePermission("EDIT_DEVICE_CONFIGURATION");
    },
    sentinelUpgrade() {
      return authoritiesHavePermission("SENTINEL_UPGRADE");
    },
    editInstallationHistory() {
      return authoritiesHavePermission("EDIT_INSTALLATION_HISTORY");
    },
    forceCalibrate() {
      return authoritiesHavePermission("FORCE_TDR_CALIBRATION");
    },
    viewMainsSupply() {
      return authoritiesHavePermission("VIEW_MAINS_SUPPLY");
    }
  }
});

function authoritiesHavePermission(permission) {
    return Vue.prototype.$keycloak.hasResourceRole(permission)
}
